import React from 'react';
const SiteSvg = () => React.createElement("span", { className: "sirius-icon sirius-icon-site" });
SiteSvg.Enhance = () => React.createElement("span", { className: "sirius-icon sirius-icon-site sirius-icon-site-enhance" });
export default SiteSvg;
